import JovMobile from './JovMobileContainer';

export default JovMobile;